import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './HorizontalPaddingInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const HorizontalPaddingInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ padding, setPadding ] = useState<number>(project.encoder.overlayHorizontalPadding);
  const debounce = 100;
  const min = 5;
  const max = 100;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = padding;

      if (padding < min) {
        value = min;
      } else if (padding > max) {
        value = max;
      }

      setPadding(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayHorizontalPadding: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayHorizontalPadding: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setPadding(project.encoder.overlayHorizontalPadding);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayHorizontalPadding]);

  return (
    <div className="horizontal-padding-input">
      <div className="input-title">
        {t('producer.inputs.horizontal-padding.title')}
        <Help
          title="Horizontal Padding"
          text="Allows you to add space to the left and the right of the captions."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.horizontal-padding.placeholder"
        value={padding.toString()}
        onChange={(value) => {setPadding(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.horizontal-padding.footer')}</div>
    </div>
  );
};

export default React.memo(HorizontalPaddingInput);
